import { formatPrice, handleize } from 'utils/general';

/**
 * @info
 *
 * *The "store/cart" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind cart functionality.
 *
 * *This file*
 * This file outlines "getters". Getters are methods
 * that perform modifications to the state value prior
 * to returning the value to the consuming component.
 */
export default {
  subtotal(state, getters, rootState) {
    return formatPrice(rootState.global.cart.total_price, false, true);
  },
  cartItemProductIsSimple: (state, getters) => (item) => {
    const product = getters.cartProductByItem(item);
    return (
      !product ||
      typeof product.collection === 'undefined' ||
      typeof product.variants === 'undefined' ||
      !(
        product.variants.length > 1 ||
        (product.collection && product.collection.length)
      )
    );
  },
  cartProductByItem: (state) => (item) => {
    const productHandle = item.handle;
    const collectionHandle = handleize(
      item.product_title.split(__GLOBAL__.productDelimiter)[0],
    );

    return (
      state.productsData[productHandle] ??
      state.productsData[collectionHandle] ??
      null
    );
  },
};
